import logoVariants from '@/assets/img/logo';
import { extra } from '@/theme/colors/palettes';
import { HStack, Image } from '@chakra-ui/react';
import { useNavigate } from '@tanstack/react-router';
import React from 'react';
import MobileDropdownMenu from '../../MobileDropdownMenu';
import ProfileDropdownMenu from '../../ProfileDropdownMenu';
import { useAuthContext } from '@/context/auth/useAuthContext';
import CustomButton from '@/components/atoms/CustomButton';
import { MOBILE_DEFAULT_PADDING, WEB_DEFAULT_PADDING } from '@/constants/ui';
import useIsWeb from '@/hooks/useIsWeb';

const MobileFirstHeader = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuthContext();

  const isWeb = useIsWeb();

  return (
    <HStack
      width={'100%'}
      padding={isWeb ? WEB_DEFAULT_PADDING : MOBILE_DEFAULT_PADDING}
      justifyContent={'space-between'}
      boxShadow="0px 4px 30px 0px #0041791A"
      backgroundColor={extra.white}
    >
      <Image
        src={logoVariants.purple252x80}
        alt="my-omnia"
        _hover={{ cursor: 'pointer' }}
        width={isWeb ? '158px' : '126px'}
        height={isWeb ? '50px' : '40px'}
        onClick={() => navigate({ to: '/' })}
      />
      {isWeb ? (
        isAuthenticated ? (
          <ProfileDropdownMenu isHeaderTransparent={false} />
        ) : (
          <CustomButton
            label="Sign In"
            onClick={() =>
              navigate({
                to: '/sign-in',
              })
            }
          />
        )
      ) : (
        <MobileDropdownMenu />
      )}
    </HStack>
  );
};

export default MobileFirstHeader;
